import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import { hasPermission } from "utils/permissionHelper";
import { PERMISSIONS } from "constants/permissionTypes";
import { MODULES } from "constants/modulesTypes";
import { Link, useSearchParams, useNavigate, useParams } from "react-router-dom";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";

let data = "";
const UserPermission = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { id } = useParams();

    const [UserPermissiondata, setUserPermissionData] = useState([]);
    const [Moduledata, setModuleData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [checkedItems, setCheckedItems] = useState(false);
    const [state, setState] = useState({});
    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem("authUser"));
    const permissions = ["Insert", "View", "Update", "Delete"];

    const permissionMap = {
        1: "Insert",
        2: "View",
        3: "Update",
        4: "Delete"
    };

    useEffect(() => {
        getUserById();
        getActiveModules();
        getUserPermissionByUserId();
    }, []);

    useEffect(() => {
        if (Moduledata.length > 0 && Object.keys(state).length === 0) {
            const initialState = {};
            Moduledata.forEach(module => {
                initialState[module.ID] = {
                    Insert: false,
                    View: false,
                    Update: false,
                    Delete: false
                };
            });
            setState(initialState);
        }
    }, [Moduledata]);

    useEffect(() => {
        const allChecked = Moduledata.every(module =>
            permissions.every(perm => state[module.ID]?.[perm])
        );
        setCheckedItems(allChecked);
    }, [state, Moduledata]);

    const permissionsMap = useSelector(
        state => state.permissions?.permissions || {}
    );

    const getUserById = async () => {
        try {
            const response = await fetch(
                `https://api.kunalsdrumclass.com/api/GetUserById?id=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const jsonData = await response.json();
            data = jsonData.recordsets[0][0];
        } catch (error) {
            console.error(error);
        }
    };

    const getActiveModules = async () => {
        try {
            const response = await fetch("https://api.kunalsdrumclass.com/api/GetActiveModules", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const jsonData = await response.json();
            setModuleData(jsonData.recordsets[0]);
        } catch (error) {
            console.error(error);
        }
    };

    const getUserPermissionByUserId = async () => {
        try {
            const response = await fetch(
                `https://api.kunalsdrumclass.com/api/GetUserPermissionByUserId?userId=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const jsonData = await response.json();
            setUserPermissionData(jsonData.recordsets[0]);

            const transformedData = {};
            jsonData.recordsets[0].forEach(item => {
                const moduleId = item.Module_Id;
                const permissionName = permissionMap[item.Permission_Id];

                if (!transformedData[moduleId]) {
                    transformedData[moduleId] = {
                        Insert: false,
                        View: false,
                        Update: false,
                        Delete: false
                    };
                }
                transformedData[moduleId][permissionName] = true;
            });

            setState(prev => ({
                ...prev,
                ...transformedData
            }));
        } catch (error) {
            console.error(error);
        }
    };

    const handleSelectAll = () => {
        const newValue = !checkedItems;
        const newState = {};

        Moduledata.forEach(module => {
            newState[module.ID] = {};
            permissions.forEach(perm => {
                newState[module.ID][perm] = newValue;
            });
        });

        setState(newState);
        setCheckedItems(newValue);
    };

    const handleCheckboxChange = (moduleId, permission) => {
        setState(prev => {
            const modulePermissions = prev[moduleId] || {
                Insert: false,
                View: false,
                Update: false,
                Delete: false
            };

            return {
                ...prev,
                [moduleId]: {
                    ...modulePermissions,
                    [permission]: !modulePermissions[permission]
                }
            };
        });
    };

    const saveUserPermission = async () => {
        try {
            setLoading(true);

            for (const [moduleId, perms] of Object.entries(state)) {
                for (const [permission, value] of Object.entries(perms)) {
                    const permissionId =
                        permission === "Insert" ? 1 :
                            permission === "View" ? 2 :
                                permission === "Update" ? 3 : 4;

                    await fetch("https://api.kunalsdrumclass.com/api/UserPermission", {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            userId: id,
                            moduleId,
                            permissionId,
                            createdBy: user.Id,
                            modifiedBy: user.Id,
                            isActive: value ? 1 : 0,
                            isDeleted: value ? 0 : 1
                        }),
                    });
                }
            }

            Swal.fire("Success!", "User Permission saved successfully!", "success")
                .then(() => navigate("/users"));

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="User Permission"
                        breadcrumbItems={[
                            { title: "Users", link: "/users" },
                            { title: "User Permission" }
                        ]}
                    />

                    <div className="d-flex justify-content-end mb-3">
                        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                            Back to List
                        </button>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h5>User: {data?.FirstName} {data?.LastName}</h5>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={checkedItems}
                                onChange={handleSelectAll}
                            />
                            <label className="form-check-label">
                                Select All
                            </label>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center my-4">
                            <Spinner color="primary" />
                        </div>
                    ) : (
                        <>
                            <div className="table-responsive mt-3">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: "60px" }}>#</th>
                                            <th>Modules</th>
                                            {permissions.map(p => <th key={p}>{p}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Moduledata.map((module, index) => (
                                            <tr key={module.ID}>
                                                <td>{index + 1}</td>
                                                <td>{module.Name}</td>
                                                {permissions.map(permission => (
                                                    <td key={permission} align="center">
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={state[module.ID]?.[permission] || false}
                                                                onChange={() =>
                                                                    handleCheckboxChange(module.ID, permission)
                                                                }
                                                            />
                                                        </div>
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {hasPermission(permissionsMap, MODULES.USERPERMISSION, PERMISSIONS.INSERT) && (
                                <div style={{ textAlign: "right", marginTop: "1rem" }}>
                                    <button className="btn btn-primary" onClick={saveUserPermission} disabled={loading}>
                                        Save
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default UserPermission;
